import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Text, Button } from "src/components";
import { Divider } from "@mui/material";
import { StyledInput, StyledLabel } from "src/components/AppInvite/MultipleInvitesForm";
import SmsIcon from "src/img/new/sms.svg";
import EmailIcon from "src/img/new/email.svg";
import CheckIcon from "src/img/new/green-check.svg";

const ErrorText = styled(Text)`
    color: red;
    text-align: center;
    font-size: 12px;
    margin: 0.25rem 0 0 0;
`;

const RadioButton = styled.button`
    border: 1px solid #000000;
    color: #000000;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px !important;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 500;
    width: auto;
    height: 49px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D8DEEC;
    opacity: 1;
    gap: 10px;
    padding: 0 1rem;

    ${props => props.active && css`
        color: #FFFFFF;
        border: 1px solid #FFFFFF;
    `}
`;

const ButtonIcon = styled.img`
    width: 20px;
    height: 20px;
    color: #000000;
`;

const ActionButtonContainer = styled.div`
    margin: 2rem 0px 0px 0px;
    position: relative;
`;

const ActionButton = styled(Button)`
    color: ${p => p.color || "#000"};
    background-color: ${p => p.backgroundColor || "#fff"};
    margin: 0 auto;
    font-size: 14px;
    border: ${p => p.border || "1px solid #000"};
    padding: ${p => p.padding || "10px 45px 10px !important"};
    display: block; 
`;

class InviteSent extends Component {
    renderMethodButtons = (inviteMethod) => {
        const Content = styled.div`
            display: flex;
            align-items: center;
            gap: 10px;
        `;

        if (inviteMethod === "email") {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <RadioButton>
                        <Content>
                            <ButtonIcon src={EmailIcon} />
                            <span>Send By Email</span>
                        </Content>
                        <ButtonIcon src={CheckIcon} style={{ width: "20px", height: "20px" }} />
                    </RadioButton>
                </div>
            );
        }

        if (inviteMethod === "sms") {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <RadioButton>
                        <Content>
                            <ButtonIcon src={SmsIcon} />
                            <span>Send By SMS</span>
                        </Content>
                        <ButtonIcon src={CheckIcon} style={{ width: "20px", height: "20px" }} />
                    </RadioButton>
                </div>
            );
        }

        if (inviteMethod === "both") {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <RadioButton>
                        <Content>
                            <ButtonIcon src={EmailIcon} />
                            <ButtonIcon src={SmsIcon} />
                            <span>Send By Email & SMS</span>
                        </Content>
                        <ButtonIcon src={CheckIcon} style={{ width: "20px", height: "20px" }} />
                    </RadioButton>
                </div>
            );
        }
        return null;
    };

    render() {
        const {
            licenseEmployee,
            inviteMethod,
            cancel,
            errorFirstName,
            errorEmail,
            errorPhoneNumber,
            smsResponseMessage,
            emailResponseMessage,
        } = this.props;

        return (
            <>
                <div style={{ width: "100%" }}>
                    <div
                        style={{
                            position: "relative",
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            gap: "1rem",
                            boxSizing: "border-box",
                            marginBottom: "2rem",
                            marginTop: "3rem",
                        }}
                    >
                        <div style={{ flex: "1", minWidth: 0, boxSizing: "border-box" }}>
                            <StyledLabel>Name</StyledLabel>
                            <StyledInput
                                value={`${licenseEmployee.firstName} ${licenseEmployee.lastName}`}
                                readOnly
                                style={{ width: "100%", boxSizing: "border-box" }}
                            />
                            {errorFirstName && <ErrorText>{errorFirstName}</ErrorText>}
                        </div>
                        <div style={{ flex: "1", minWidth: 0, boxSizing: "border-box" }}>
                            <StyledLabel>Email</StyledLabel>
                            <StyledInput
                                value={licenseEmployee.email}
                                readOnly
                                style={{ width: "100%", boxSizing: "border-box" }}
                            />
                            {errorEmail && <ErrorText>{errorEmail}</ErrorText>}
                        </div>
                        <div style={{ flex: "1", minWidth: 0, boxSizing: "border-box" }}>
                            <StyledLabel>Mobile</StyledLabel>
                            <StyledInput
                                value={licenseEmployee.phoneNumber}
                                readOnly
                                style={{ width: "100%", boxSizing: "border-box" }}
                            />
                            {errorPhoneNumber && <ErrorText>{errorPhoneNumber}</ErrorText>}
                        </div>
                    </div>
                    <div>{this.renderMethodButtons(inviteMethod)}</div>
                    {(smsResponseMessage || emailResponseMessage) && (
                        <div style={{ marginTop: "1rem", textAlign: "center" }}>
                            {inviteMethod === "sms" && smsResponseMessage && (
                                <ErrorText>{smsResponseMessage}</ErrorText>
                            )}
                            {inviteMethod === "email" && emailResponseMessage && (
                                <ErrorText>{emailResponseMessage}</ErrorText>
                            )}
                            {inviteMethod === "both" && (
                                <>
                                    {emailResponseMessage && (
                                        <ErrorText>Email: {emailResponseMessage}</ErrorText>
                                    )}
                                    {smsResponseMessage && (
                                        <ErrorText>SMS: {smsResponseMessage}</ErrorText>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
                <Divider style={{ width: "100%", position: "absolute", left: 0, marginTop: "1rem" }} />
                <ActionButtonContainer>
                    <ActionButton backgroundColor="#FFFFFF" color="#000" onClick={cancel}>
                        Close
                    </ActionButton>
                </ActionButtonContainer>
            </>
        );
    }
}

export default InviteSent;
